module.exports = __webpack_public_path__ + "img/19.2fe5c172.png";